import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

const checkStockApi = (queryString, includeMTM) => {
  if (includeMTM) {
    const checkFunc = async () => {
      try {
        const response = await client.get(
          'confirm_availability?' + queryString
        );
        if (response.data.success == true) {
          document.getElementById('checkout_btn').click();
        } else {
          document.getElementById('cart_caution').classList.add('active');
        }
      } catch (error) {
        console.error('在庫確認中にエラーが発生しました:', error);
        document.getElementById('cart_caution').classList.add('active');
      }
    };
    checkFunc();
  } else {
    document.getElementById('checkout_btn').click();
  }
};

const checkQueryString = () => {
  fetch('/cart.js')
    .then((response) => {
      if (!response.ok) {
        throw new Error('リクエスト失敗: ', response.status);
      }
      return response.json();
    })
    .then((data) => {
      var stockArry = [];
      var includeMTM = false;
      for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].product_type == 'MTM') {
          includeMTM = true;
          var variant = '';
          var j1 = data.items[i].properties;
          var keyList = Object.keys(j1);
          var index = 0;
          for (var k1 in keyList) {
            if (keyList[k1].includes('_base_size_')) {
              variant = keyList[k1];
              variant = variant.split('_');
              var base_size = variant[3];
              var data_tmp = {};
              data_tmp.baseSize = base_size;
              data_tmp.count = data.items[i].quantity;
              stockArry.push(data_tmp);
            }
            index = index + 1;
          }
        }
      }

      let resultArr = [];
      stockArry.forEach((obj) => {
        const existingObj = resultArr.find(
          (item) => item.baseSize === obj.baseSize
        );
        if (existingObj) {
          existingObj.count += obj.count;
        } else {
          resultArr.push({ ...obj });
        }
      });

      let queryString = '';
      resultArr.forEach((item, index) => {
        queryString +=
          'items[' +
          index +
          '][id]=' +
          item.baseSize +
          '&items[' +
          index +
          '][count]=' +
          item.count +
          '&';
      });

      if (queryString.endsWith('&')) {
        queryString = queryString.slice(0, -1);
      }

      checkStockApi(queryString, includeMTM);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};

const dummyBtn = () => {
  const checkout = document.getElementById('cart_btn');
  checkout.addEventListener('click', () => {
    checkout.classList.add('btn--loading');
    checkQueryString();
  });
};

document.addEventListener('DOMContentLoaded', () => {
  // ダミーチェックアウトボタン押時（在庫API）
  dummyBtn();

  // エラーモーダル
  const checkoutCloseBtn =
    document.getElementsByClassName('cart_caution_close');
  for (var i = 0; i < checkoutCloseBtn.length; i++) {
    checkoutCloseBtn[i].addEventListener('click', function () {
      document.getElementById('cart_caution').classList.remove('active');
    });
  }

  // caution表示後、カートページに遷移時にloadingボタンを削除
  const cartLoading = document.getElementById('cart_btn');
  const backBtn = [
    document.getElementById('cart_caution_back'),
    document.getElementById('cart_caution_closeBtn')
  ];
  backBtn.forEach((btn) => {
    btn.addEventListener('click', () => {
      cartLoading.classList.remove('btn--loading');
    });
  });

  // カート数量変更監視に関するMutationObserverの設定
  const observer = new MutationObserver(() => {
    if (cartLoading.className.indexOf('btn--loading')) {
      var inputAdjust = document.getElementsByClassName('js-qty__adjust');
      for (var i = 0; i < inputAdjust.length; i++) {
        inputAdjust[i].setAttribute('disabled', true);
      }
      var quantitySection = document.getElementsByClassName('js-qty__wrapper');
      for (var j = 0; j < quantitySection.length; j++) {
        quantitySection[j].style.opacity = 0.3;
      }
    }
    dummyBtn();
  });
  observer.observe(cartLoading, { attributes: true });
});

// カート数量変更監視
window.addEventListener('pageshow', () => {
  if (window.performance.navigation.type == 2) location.reload();

  var inputAdjust = document.getElementsByClassName('js-qty__adjust');
  for (var i = 0; i < inputAdjust.length; i++) {
    inputAdjust[i].removeAttribute('disabled');
  }
  var quantitySection = document.getElementsByClassName('js-qty__wrapper');
  for (var j = 0; j < quantitySection.length; j++) {
    quantitySection[j].style.opacity = 1;
  }

  dummyBtn();
});
